export function isFileValid(file: File): boolean {
  return bytesToMB(file.size) < 20;
}

function bytesToMB(bytes: number): number {
  const bytesInOneMB = 1024 * 1024;
  return bytes / bytesInOneMB;
}
